module.exports = __webpack_public_path__ + "../resources/images/emptyJunkFolder-1d9384000027d2f713152ab7fd29d8eb.svg";